import { InputSwitch } from "primereact/inputswitch";
import { classNames } from "primereact/utils";

import { Dialog } from "../dialog";
import { DialogFooter } from "../dialog-footer";
import { FormField } from "../form-field";
import { Icon } from "../icon";
import styles from "./gantt-indicators-dialog.module.scss";
import { GANTT_INDICATORS_SAVE_LABEL } from "./messages";
import type { GanttIndicatorsDialogViewModel } from "./types-gantt-indicators-dialog";

export function GanttIndicatorsDialogView({
  visible,
  title,
  className,
  style,
  classNames: parts,
  cancel,
  save,
  testId,
  dialogTestId,
  footerTestId,
  saveTestId,
  warningTestId,
  atMinimum,
  message,
  items,
  rest,
}: GanttIndicatorsDialogViewModel) {
  return (
    <Dialog
      visible={visible}
      onHide={cancel}
      size="sm"
      data-testid={dialogTestId}
      className={classNames(styles.root, className)}
      style={style}
      header={title}
      headerClassName={parts?.header}
      contentClassName={parts?.body}
      footer={
        <DialogFooter
          data-testid={footerTestId}
          testId={testId}
          confirmTestId={saveTestId}
          confirmLabel={GANTT_INDICATORS_SAVE_LABEL}
          onCancel={cancel}
          onConfirm={save}
          className={parts?.footer}
          cancelClassName={parts?.cancel}
          confirmClassName={parts?.confirm}
        />
      }
      {...rest}
    >
      {atMinimum ? (
        <p
          className={classNames(styles.warning, parts?.warning)}
          role="alert"
          data-testid={warningTestId}
        >
          <Icon name="exclamation-triangle" size={18} />
          {message}
        </p>
      ) : (
        <p className={classNames(styles.hint, parts?.hint)}>
          <Icon name="info-circle" size={18} />
          {message}
        </p>
      )}
      <ul className={classNames(styles.list, parts?.list)}>
        {items.map((item) => (
          <li
            key={item.key}
            className={classNames(styles.item, parts?.item)}
            data-off={item.checked ? undefined : ""}
            data-testid={item.rowTestId}
          >
            <span className={styles.dot} style={{ background: item.color }} aria-hidden />
            <FormField.Root
              testId={item.toggleTestId}
              labelPosition="right"
              help={item.description}
              disabled={item.locked}
            >
              <FormField.Label>{item.label}</FormField.Label>
              <FormField.Control>
                <InputSwitch checked={item.checked} onChange={item.onToggle} />
              </FormField.Control>
              <FormField.Help />
            </FormField.Root>
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
